import {
  Betas,
  HistoricalScenarios,
  InvestmentOrder,
  RiskFactors,
  DefinedBenefitWeights,
} from "./riskData";

function median(arr) {
  const sorted = [...arr].sort((a, b) => a - b);
  const n = sorted.length;
  return n % 2
    ? sorted[Math.floor(n / 2)]
    : (sorted[n / 2 - 1] + sorted[n / 2]) / 2;
}

function computeScenario(rfValues) {
  const results = [];

  InvestmentOrder.forEach((inv) => {
    const betasRow = Betas[inv];
    const scenarioVals = betasRow.map((b, i) => b * rfValues[i]);

    results.push({
      Investment: inv,
      Min: Math.min(...scenarioVals),
      Median: median(scenarioVals),
      Max: Math.max(...scenarioVals),
    });
  });

  const wsum = DefinedBenefitWeights.reduce((a, b) => a + b, 0);

  const minAgg =
    results
      .map((r, i) => r.Min * DefinedBenefitWeights[i])
      .reduce((a, b) => a + b, 0) / wsum;

  const medAgg =
    results
      .map((r, i) => r.Median * DefinedBenefitWeights[i])
      .reduce((a, b) => a + b, 0) / wsum;

  const maxAgg =
    results
      .map((r, i) => r.Max * DefinedBenefitWeights[i])
      .reduce((a, b) => a + b, 0) / wsum;

  results.push({
    Investment: "IAM Defined Benefit",
    Min: minAgg,
    Median: medAgg,
    Max: maxAgg,
  });

  const resultsPercentage = results.map((r) => ({
    Investment: r.Investment,
    Min: (r.Min * 100).toFixed(2) + "%",
    Median: (r.Median * 100).toFixed(2) + "%",
    Max: (r.Max * 100).toFixed(2) + "%",
  }));

  return resultsPercentage;
}

// ----------------------
// PUBLIC API
// ----------------------

export function runHistoricalScenario(name) {
  const scenario = HistoricalScenarios[name];
  if (!scenario) throw new Error(`Scenario "${name}" no existe`);
  return computeScenario(scenario);
}

export function runCustomScenario(percentages) {
  if (percentages.length !== RiskFactors.length) {
    throw new Error("La cantidad de factores no coincide");
  }

  const rfNormalized = percentages.map((p) => (p || 0) / 100);
  return computeScenario(rfNormalized);
}
